import type { Component, Entity2D } from '../../odie';

import { CandyBagBlockProps } from '../defs/block';
import { CandyBagBlockView } from '../views/blocks/CandyBagBlockView';

// types
//-----------------------------------------------------------------------------
export type CandyBagBlockComponentOptions = {
  props: CandyBagBlockProps;
};

/*
    candy bag block component
*/
export class CandyBagBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCandyBag';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CandyBagBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CandyBagBlockComponentOptions): void {
    // create candy bag block view
    this.view = new CandyBagBlockView(options.props);
  }
}
